import { CustomFieldMetaData } from "~/const/CustomFieldMetaData";
import { projectBillingType, taskBillingType } from "~/utils/getBillingType";

// @ts-ignore
window.ep = window.ep || {};

export const TaskDependencyTypes = {
    None: 0,
    FinishToStart: 2,
    StartToStart: 1,
    StartToFinish: 3,
};

// @ts-ignore
ep.TaskDependencyTypes = TaskDependencyTypes;

const Keys = {
    backspace: 8,
    tab: 9,
    enter: 13,
    esc: 27,
    space: 32,
    pageUp: 33,
    pageDown: 34,
    end: 35,
    home: 36,
    left: 37,
    up: 38,
    right: 39,
    down: 40,
    del: 46,
    zero: 48,
    nine: 57,
};

// @ts-ignore
ep.Keys = Keys;

export const healthStatus = {
    Ok: 0,
    Warning: 1,
    Trouble: 2,
};

// @ts-ignore
ep.healthStatus = healthStatus;

export const descriptors = {
    int: {
        max: CustomFieldMetaData.NumericNumberMaxValue,
        min: CustomFieldMetaData.NumericNumberMinValue,
    },

    decimal: {
        max: CustomFieldMetaData.NumericMaxValue,
        min: CustomFieldMetaData.NumericMinValue,
    },
};

// @ts-ignore
ep.descriptors = descriptors;

// @ts-ignore
ep.taskBillingType = taskBillingType;

// @ts-ignore
ep.projectBillingType = projectBillingType;

export const listItemType = {
    Project: "Project", // also used for details models
    Task: "Task", // also used for details models
    Issue: "Issue",
    Request: "Request",
    Empty: "Empty",
    EmptySpace: "EmptySpace",

    isProject(item: string) {
        return item === listItemType.Project;
    },

    isActivity(item: string) {
        if (item === listItemType.Task || item === listItemType.Issue || item === listItemType.Request) {
            return true;
        }

        return false;
    },
};

// @ts-ignore
ep.listItemType = listItemType;

export const events = {
    entityDeleted: "entitydeleted",
    modalWindowClosed: "ep/modalwindowclosed",
};

// @ts-ignore
ep.events = events;

export const days = {
    sunday: "Sunday",
    monday: "Monday",
    tuesday: "Tuesday",
    wednesday: "Wednesday",
    thursday: "Thursday",
    friday: "Friday",
    saturday: "Saturday",
};

// @ts-ignore
ep.days = days;

// note : sync with UpdateContextType enum
export const updateContextType = {
    ActivityCenter: "ActivityCenter",
    Default: "Default",
};

// @ts-ignore
ep.updateContextType = updateContextType;

export const customFieldTypes = {
    string: "String",
    numeric: "Numeric",
    date: "Date",
    boolean: "Boolean",
    list: "List",
    textarea: "Textarea",
    textarearich: "Textarearich",
    hyperlink: "Hyperlink",
    multiselect: "MultiSelect",
};

// @ts-ignore
ep.customFieldTypes = customFieldTypes;

export const errorType = {
    duplicateObject: "DuplicateObject",
    isEmpty: "IsEmpty",
    passwordDoesNotMeetPolicy: "PasswordDoesNotMeetPolicy",
};

// @ts-ignore
ep.errorType = errorType;

export const ResponseErrorTypes = {
    ObjectNotFound: "ObjectNotFound",
    UserFriendlyError: "UserFriendlyError",
    UpgradePlanRequired: "UpgradePlanRequired",
    ServerVersionException: "ServerVersionException",
    UnknownError: "UnknownError",
    ForbiddenError: "ForbiddenError",
    InvalidParameters: "InvalidParameters",
    FormulaParseError: "FormulaParseError",
};
